<template>
  <div class="foot">
    <div class="footer">
      <div class="bottom">
        企服易创 |  COPYRIGHT © 2016-2024
      </div>
    </div>
    <el-backtop>
      <img class="backtop" src="../assets/images/top.png" alt="">
    </el-backtop>

  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      scrollTop: null, //页面滚动高度
    }
  },
  created() {},
  mounted() {},
  methods: {
  },
  filters: {},
  computed: {},
  watch: {},
}
</script>

<style lang="less" scoped>
.foot {
  padding: 0;
  background: #fff;
  position: relative;
  height: 60px;
  border-top: 1px solid  #F3F3F3;;
  .logo {
    width: 100%;
  }
}
.backtop {
  width: 30px;
  height: 30px;
}
.footer{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 40px;
  padding-right: 55px;
  height: 70px;
  color: #F74C67 !important;
  .copy{
    cursor: pointer;
  }
  img{
    height: 38px;
	padding-left: 140px;
  }
  .bottom{
    display: flex;
    align-items: center;
    font-size: 14px;
	font-size: 12px;
    color: #F74C67;
    .item{
      border-right: 1px solid #fff;
      padding: 0 10px;
      &:last-child{
        border-right: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageFooter_p.vue